import React, {useEffect, useState} from 'react';
// Image Templates
import Discount from "../../../../../assets/TemplateImages/Discount.png"
import Launch from "../../../../../assets/TemplateImages/Launch.png"
import OfferImage from "../../../../../assets/TemplateImages/Offer.png"
import Events from "../../../../../assets/TemplateImages/Events.png"
import {app, SECRETS_ENV} from "../../../../../Config/firebase.ts";
import { useNavigate } from 'react-router-dom';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
const CRYPTO_SECRET = import.meta.env.VITE_CRYPTO_SECRET || process.env.VITE_CRYPTO_SECRET

import {
    Box,
    Button,
    Checkbox,
    CircularProgress,
    Divider,
    FormControl,
    FormControlLabel,
    InputAdornment,
    MenuItem,
    TextField,
    Tooltip,
    Typography
} from '@mui/material';
import {Add, Clear, Download, Info, Refresh, Send, Upload} from '@mui/icons-material';
import Papa from 'papaparse';
import {addDoc, collection, getFirestore, onSnapshot, query} from 'firebase/firestore';
import {RootState, useAppDispatch, useAppSelector} from '../../../../../state/state.tsx';
import WhatsappChatBubble from "./WhatsappChatBubble.tsx";
import TextEditor from "./TextEditor.tsx";
import {useBackend} from "../../../../../hooks/backend/useBackend.ts";
import {toast} from "react-toastify";
import {openModal} from "../../../../../state/ModalSlice/ModalSlice.ts";
import {LiveSubscriptionType} from "../../../types/LiveSubscriptionTypes.ts";
import {UserStateV2} from "../../../types/UserStateV2.ts";
import { Offer, OfferConstraint } from '../../../Pages/Offers/Offers.tsx';
import { AES } from 'crypto-js';
import { selectEffectiveUID } from '../../../../../state/UserStatesV2/userSliceV2.ts';

const imageTemplates: any = {
    discount: Discount,
    newLaunch: Launch,
    offerCode: OfferImage,
    eventPromotions: Events
}


const generateCSVTemplate = () => {
    const csvContent = "data:text/csv;charset=utf-8,"
        + "Name,Number\n"
        + "John Doe,1234567890\n"
        + "Jane Smith,0987654321";

    return encodeURI(csvContent);
};

type MessageTemplates = {
    newLaunch: string;
    offerCode: string;
    discount: string;
    eventPromotions: string;
};

const messageTemplates: MessageTemplates = {
    newLaunch: "we're excited to announce our new product launch! Check it out now get exclusive offers for first 100 users!",
    offerCode: "Get {discount amount} off your next purchase with us when you use the code {discount code} at checkout.",
    discount: "Get up to 50% off on all items until 10th June 🤯",
    eventPromotions: "Join us on [Event Date] for a night of fun, food, and shopping. You'll get to enjoy exclusive discounts on all our products and a chance to win exciting prizes."
};

const Growth: React.FC = () => {

    const [leads, setLeads] = useState<{ name: string, number: string }[]>([]);
    const [selectedLeads, setSelectedLeads] = useState<Set<number>>(new Set());
    const [message, setMessage] = useState(messageTemplates.newLaunch);
    const [template, setTemplate] = useState<string>('newLaunch');
    const [nameInput, setNameInput] = useState('');
    const [numberInput, setNumberInput] = useState('');
    const [, setFileInputTriggered] = useState(false);
    const ServiceProviderId: string = useAppSelector(selectEffectiveUID);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const ServiceProviderProfileV2: UserStateV2 | undefined = useAppSelector((state: RootState) => state.userSliceV2.data as UserStateV2)
    const userState = useAppSelector((state: RootState) => state.userSliceV2.data);

    const db = getFirestore(app);

    const Dispatch = useAppDispatch();
    const navigate = useNavigate();
    
    // Handler functions
    const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file && file.type === 'text/csv') {
            Papa.parse(file, {
                header: true,
                skipEmptyLines: true,
                complete: (results) => {
                    const data = results.data as { Name: string, Number: string }[];
                    const parsedLeads = data.map(item => ({
                        name: item.Name || 'Unknown',
                        number: item.Number || 'Unknown'
                    }));
                    setLeads(parsedLeads);
                    setSelectedLeads(new Set(parsedLeads.map((_, index) => index)));
                },
                error: (error) => {
                    console.error("Error parsing CSV file:", error);
                }
            });
        } else {
            console.error("Unsupported file type");
        }
        setFileInputTriggered(false);
    };


    const handleMessageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setMessage(event.target.value);
    };

    
    const handleTemplateChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        const selectedTemplate = event.target.value as string;
        setTemplate(selectedTemplate);
        setWhatsappImageFile(null);
        setWhatsappImagePreview("");
        setSelectedOffer(null);

        if (selectedTemplate in messageTemplates) {
            setMessage(messageTemplates[selectedTemplate as keyof MessageTemplates]);
        } else {
            const offer = offers.find(o => o.id === selectedTemplate);
            if (offer) {
                setSelectedOffer(offer);
                setMessage(offer.BuzzName +"!!" + offer.Description + ". Please use offer code " + offer.OfferCode + " to avail benefits." + "Offer applicable on "+ offer.offerConstraint );
                setWhatsappImagePreview(offer.url);
            }
        }
    };

    const handleChangeNumberInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        const {value} = event.target;
        // -------------Function to handle only decimal and number inputs
        if (value.length > 10) {
            return;
        }

        if (!value) {
            setNumberInput("")
            return;
        }

        for (let i = 0; i < value.length; i++) {
            const char = value[i];
            if (char >= '0' && char <= '9') { /* empty */
            } else {
                return;
            }
        }
        setNumberInput(value)
    }

    const handleCheckboxChange = (index: number) => {
        const newSelectedLeads = new Set(selectedLeads);
        if (newSelectedLeads.has(index)) {
            newSelectedLeads.delete(index);
        } else {
            newSelectedLeads.add(index);
        }
        setSelectedLeads(newSelectedLeads);
    };


    const handleClearAll = () => {
        setMessage('');
    };

    const handleClearLeads = () => {
        setLeads([]);
        setSelectedLeads(new Set());
    }

    function onClickBuyMoreCredits(){


        const encoded = AES.encrypt(JSON.stringify({
            planType: "Custom Credits",
            amount: 100, 
            providerId: ServiceProviderId,
            customerDetails: {
                customerId: userState?.uid || '',
                customerPhone: userState?.phone_number || '',
                customerName: userState?.display_name || '',
                customerEmail: userState?.email || '',
            },
            isEditable: true,
            isCreditPurchase: true,
        }), CRYPTO_SECRET).toString();


        
        navigate(`/payments?data=${encodeURIComponent(encoded)}`);
    }

    // Onsubmit Operations

    const handleNewLineFormat = () => {
        const textWithNewlines = message.replace(/\n/g, ' \n ');
        return textWithNewlines
        // Youcan now use the `textWithNewlines` variable as needed
    };

    


    async function urlToFile(url: string, filename: string, mimeType: string) {
        const response = await fetch(url);
        const buffer = await response.arrayBuffer();
        return new File([buffer], filename, {type: mimeType});
    }

    const {uploadFileInFirestore, axiosPostRequest} = useBackend("")
    const userId = useAppSelector(selectEffectiveUID);

    const handleSendMessage = async () => {
        setIsLoading(true);

        let uploadFile: any;
        let imageUrl: string;

        if (WhatsappImageFile) {
            uploadFile = WhatsappImageFile;
            imageUrl = await uploadFileInFirestore(userId, uploadFile);
        } else if (selectedOffer) {
            imageUrl = selectedOffer.url;
        } else {
            const templateUrl = imageTemplates[template];
            uploadFile = await urlToFile(templateUrl, `${template}.png`, 'image/png');
            imageUrl = await uploadFileInFirestore(userId, uploadFile);
        }

        if (imageUrl === "error") {
            setIsLoading(false);
            toast.error("An error occurred please try again");
            return;
        }

        const selectedLeadsArray = Array.from(selectedLeads);
        const messages = selectedLeadsArray.map(index => ({
            name: leads[index].name,
            number: leads[index].number,
            message: message.replace("{name}", leads[index].name)
        }));

        const customerList = messages.map(lead => ({
            name: lead.name,
            number: lead.number
        }));

        

        try {
            const CampaignCollectionReference = collection(
                db,
                'ServiceProviders',
                ServiceProviderId,
                'Campaigns'
            );

            const campaignDocRef = await addDoc(CampaignCollectionReference, {
                message: handleNewLineFormat(),
                template: selectedOffer ? selectedOffer.offerConstraint : template,
                customerList: customerList,
                providerReference: ServiceProviderId,
                timestamp: new Date(),
                photo_url: imageUrl,
                offerId: selectedOffer ? selectedOffer.id : null,
                offerCode: selectedOffer ? selectedOffer.OfferCode : null,
            });

           
            // Trigger the sendCampaignMessages API with the new campaign ID
            const campaignId = campaignDocRef.id;
            const response = await axiosPostRequest(`${SECRETS_ENV.API_END_POINT}/api/sendCampaignImageMessages`, {
                providerId: ServiceProviderId,
                campaignId: campaignId
            })


            if (response.message === "Request successful") {
                toast.success('Campaign messages sent successfully');
            } else {
                if (response.status.toString() == "402") {
                    toast.error("Insufficient Credits - Please Recharge Your Account")
                } else {
                    toast.error('Failed to send campaign messages');
                }
            }


        } catch (error) {
            setIsLoading(false)
            console.error('Error saving message data or sending campaign messages:', error);
        }

        setSelectedLeads(new Set());
        setIsLoading(false);
    };


    const fetchExistingCustomers = async () => {

        Dispatch(openModal("FetchExistingSubscribersModalOpen"))

        // setLeads(dummyExistingCustomers);
        // setSelectedLeads(new Set(dummyExistingCustomers.map((_, index) => index)));
    };

    // Post-Fill fetch existing customers

    const subscriberFromFetchExistingSubscribers: LiveSubscriptionType[] = useAppSelector((state: RootState) => state.ArbitrarySlice.ForFetchExistingSubscribersModal.data)

    useEffect(() => {
        if (subscriberFromFetchExistingSubscribers) {
            const newFormat = subscriberFromFetchExistingSubscribers.map((data) => ({
                name: data.name,
                number: data.phoneNumber
            }));

            setLeads((prevLeads) => {
                // Filter out any new entries that are already present in prevLeads
                const filteredNewFormat = newFormat.filter((newLead) => {
                    return !prevLeads.some(
                        (existingLead) =>
                            existingLead.name === newLead.name && existingLead.number === newLead.number
                    );
                });

                // Return the new array with the filtered data appended
                const updatedLeads = [...prevLeads, ...filteredNewFormat];

                // Create a set of indices for the updated leads
                const updatedSelectedLeads = new Set<number>(
                    updatedLeads.map((_, index) => index)
                );

                // Update the selectedLeads state to mark all as checked
                setSelectedLeads(updatedSelectedLeads);

                return updatedLeads;
            });
        }
    }, [subscriberFromFetchExistingSubscribers]);


    const handleAddLead = () => {
        if (nameInput && numberInput) {
            const newLead = {name: nameInput, number: "+91" + numberInput};
            setLeads([...leads, newLead]);
            setSelectedLeads(new Set([...selectedLeads, leads.length]));
            setNameInput('');
            setNumberInput('');
        }
    };


    // Text editor
    const insertAtCursor = (symbol: string) => {
        const textarea: HTMLTextAreaElement | null = document.getElementById(
            "editor"
        ) as HTMLTextAreaElement | null;
        if (!textarea) return;

        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const selectedText = message.slice(start, end);

        let newText;
        if (
            message.slice(start - symbol.length, start) === symbol &&
            message.slice(end, end + symbol.length) === symbol
        ) {
            // If the selected text is already wrapped with the symbol, remove the symbols
            newText =
                message.slice(0, start - symbol.length) +
                selectedText +
                message.slice(end + symbol.length);
            setMessage(newText);
            // handleMessageChange(newText);

            // Set the cursor position after removing the symbols
            setTimeout(() => {
                textarea.setSelectionRange(start - symbol.length, end - symbol.length);
                textarea.focus();
            }, 1);
        } else {
            // Otherwise, add the symbols around the selected text
            newText =
                message.slice(0, start) +
                symbol +
                selectedText +
                symbol +
                message.slice(end);
            setMessage(newText);
            // handleMessageChange(newText);

            // Set the cursor position after inserting the symbols
            setTimeout(() => {
                textarea.setSelectionRange(
                    start + symbol.length,
                    end + symbol.length
                );
                textarea.focus();
            }, 1);
        }
    };


    // Whatsapp Image

    const [WhatsappImageSizeExceeded, setWhatsappImageSizeExceeded] = useState(false);
    const [WhatsappImageFile, setWhatsappImageFile] = useState<File | null>(null);
    const [WhatsappImagePreview, setWhatsappImagePreview] = useState<string>("");

    // TODO: Use it when image field is made as optional
    // const [includeImage, setIncludeImage] = useState<boolean>(true);

    const handleWhatsappImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files ? event.target.files[0] : null;
        setWhatsappImageSizeExceeded(false);

        if (file) {
            if (file.size > 5 * 1024 * 1024) {
                setWhatsappImageSizeExceeded(true);
                return;
            }
            setWhatsappImageFile(file);
            setSelectedOffer(null);

            const reader = new FileReader();
            reader.onloadend = () => {
                setWhatsappImagePreview(reader.result as string);
            };
            reader.readAsDataURL(file);
        }
    };

    const [selectedOffer, setSelectedOffer] = useState<Offer | null>(null);

    const [offers, setOffers] = useState<Offer[]>([]);

    useEffect(() => {
        if (ServiceProviderId) {
            const offersRef = collection(db, 'ServiceProviders', ServiceProviderId, 'Offers');
            const q = query(offersRef);

            const unsubscribe = onSnapshot(q, (snapshot) => {
                const offersList: Offer[] = [];
                snapshot.forEach((doc) => {
                    offersList.push({ id: doc.id, ...doc.data() } as Offer);
                });
                setOffers(offersList);
            }, (error) => {
                console.error("Error fetching offers: ", error);
            });

            return () => unsubscribe();
        }
    }, [ServiceProviderId]);


    return (

        <div className={"flex flex-col gap-4 "}>

            <div
                className="w-full border-[1px] border-gray-300  shadow-[0px_0px_4px_2px_rgba(0,0,0,0.1)] rounded-xl p-5"
                style={{
                    background: "linear-gradient(90deg, rgba(29,78,216,0.0145) 0%, rgba(29,78,216,0.1339) 44%, rgba(29,78,216,0.0313) 98%)",
                    // Fallback color if gradient isn't supported
                }}
            >

                <div className={"flex p-4 py-6 justify-between items-center"}>
                    <div>
                        <p className={"font-semibold text-lg"}>{ServiceProviderProfileV2?.display_name}, your available
                            Credits are</p>
                        
                        <span><p className={"font-semibold text- mt-1"}><span
                            className={"text-3xl font-semibold mr-1.5"}>{ServiceProviderProfileV2?.Credits}</span>Credits 
                            <Tooltip title="Credits are immediately refunded for failed messages." arrow>
                                <Info fontSize="small" className=" ml-2 text-gray-500 cursor-help" />
                            </Tooltip>
                        </p></span>
                        <p className={"text-sm mt-1 font-medium text-cc_brand"}>1 credit = 1 message</p>
                    </div>
                    <div>
                        <button onClick={onClickBuyMoreCredits}
                                className={`w-full bg-cc_brand text-white p-1.5 px-4 rounded-2xl border-gray-500 flex justify-center items-center cursor-pointer `}>

                            Buy more Credits
                        </button>
                    </div>
                </div>
            </div>


            <div className="flex gap-4">

                <div className={"w-full  rounded-xl bg-white p-5 border-[1px] border-gray-300 shadow-[0px_0px_4px_2px_rgba(0,0,0,0.1)] "}>
                    <div>
                        <p className={"text-black text-2xl font-semibold"}>Generate Whatsapp Messages</p>

                        <div className={"mt-6 flex flex-col gap-4"}>
                            <FormControl fullWidth sx={{mb: 2}}>
                                <TextField
                                    select
                                    size={"small"}
                                    label="Select Template or Offer"
                                    variant="outlined"
                                    value={selectedOffer ? selectedOffer.id : template}
                                    onChange={handleTemplateChange}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: 'grey',
                                                borderRadius: '10px'
                                            },
                                            '&:hover fieldset': {
                                                borderColor: 'grey',
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: 'skyblue',
                                            },
                                            '& .MuiInputBase-input': {
                                                fontSize: '14px',
                                            },
                                        },
                                        fontWeight: 400
                                    }}
                                >
                                    <MenuItem value="newLaunch">New Launch</MenuItem>
                                    <MenuItem value="offerCode">Offer Code</MenuItem>
                                    <MenuItem value="discount">Discount</MenuItem>
                                    <MenuItem value="eventPromotions">Event Promotions</MenuItem>
                                    {offers.map((offer) => (
                                        <MenuItem key={offer.id} value={offer.id}>
                                            {offer.BuzzName}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </FormControl>


                            <TextEditor message={message} handleMessageChange={handleMessageChange}
                                        insertAtCursor={insertAtCursor}/>


                        </div>

                        <div className={"flex gap-4 mt-8 items-center"}>

                            {/*<FormControlLabel*/}
                            {/*    control={<Checkbox checked={includeImage} size={"small"}*/}
                            {/*                       onChange={(event: React.ChangeEvent<HTMLInputElement>) => {*/}
                            {/*                           setIncludeImage(event.target.checked)*/}
                            {/*                       }}*/}
                            {/*                       inputProps={{'aria-label': 'controlled'}}*/}
                            {/*/>}*/}
                            {/*    label="Include Image"*/}
                            {/*    sx={{*/}
                            {/*        '& .MuiFormControlLabel-label': {*/}
                            {/*            fontSize: '14px'*/}
                            {/*        }*/}
                            {/*    }}*/}
                            {/*/>*/}

                            <Button
                                variant="outlined"
                                component="label"

                                sx={{
                                    mb: 0,
                                    borderRadius: '8px',
                                    textTransform: 'none',
                                    color: '#ffffff',
                                    borderColor: '#1D4ED8',
                                    backgroundColor: "#1D4ED8",
                                    '&:hover': {
                                        backgroundColor: '#1D4ED8',  // Maintain the same background color on hover
                                        borderColor: '#1D4ED8'
                                    }
                                }}
                            >
                                Upload Image <span className={"text-sm ml-2"}>(Max 5mb)</span>
                                <input
                                    type="file"
                                    accept="image/jpeg, image/png"
                                    hidden
                                    onChange={handleWhatsappImageChange}
                                />
                            </Button>
                            {WhatsappImageSizeExceeded &&
                                <p className={"text-cc_error text-sm"}>File size exceeded please upload image less than
                                    5mb.</p>}
                        </div>


                        <Divider sx={{mt: 4}}/>

                        <p className={"text-black text-2xl font-semibold mt-4"}>Add Leads</p>

                        <div className={" buttons mt-8"}>
                            <div className={"flex gap-4"}>
                                <a href={generateCSVTemplate()} download="leads_template.csv">

                                    <button
                                        className={`bg-gray-100 border-[1px] border-solid border-gray-400 hover:bg-gray-200 py-1.5 px-3 rounded-xl cursor-pointer flex gap-2 font-medium shadow-lg hover:shadow-xl`}>
                                        <Download/>
                                        Download Sample Template
                                    </button>
                                </a>
                                <div>
                                    <input
                                        accept=".csv"
                                        style={{display: 'none'}}
                                        id="upload-file"
                                        type="file"
                                        onChange={handleFileUpload}
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                    <label htmlFor="upload-file" style={{width: '100%'}}>
                                        <button
                                            onClick={(e) => {
                                                e.preventDefault();
                                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                // @ts-expect-error
                                                document.getElementById('upload-file').click(); // Trigger the click on the input element
                                                setFileInputTriggered(true);
                                            }}
                                            className=" bg-gray-100 border-[1px] border-solid border-gray-400 hover:bg-gray-200 py-1.5 px-3 rounded-xl cursor-pointer flex gap-2 font-medium shadow-lg hover:shadow-xl"
                                        >
                                            <Upload/>
                                            Upload Leads File
                                        </button>
                                    </label>
                                </div>


                                <button onClick={fetchExistingCustomers}
                                        className={` bg-gray-100 border-[1px] border-solid border-gray-400 hover:bg-gray-200 py-1.5 px-3 rounded-xl cursor-pointer flex gap-2 font-medium shadow-lg hover:shadow-xl`}>
                                    <Refresh/>
                                    Fetch Existing Customers
                                </button>

                                <button onClick={handleClearAll}
                                        className={` bg-gray-100 border-[1px] border-solid border-gray-400 hover:bg-gray-200 py-1.5 px-3 rounded-xl cursor-pointer flex gap-2 font-medium shadow-lg hover:shadow-xl`}>
                                    <Clear/>
                                    Clear Message
                                </button>

                            </div>


                        </div>

                        <div className={"inputs-name-and-mobile flex gap-4 mt-8"}>
                            <TextField
                                label="Customer Name"
                                variant="outlined"
                                fullWidth
                                size={"small"}

                                value={nameInput}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: 'grey', borderRadius: '10px'// Default border color
                                        }, '&:hover fieldset': {
                                            borderColor: 'grey', // Border color on hover
                                        }, '&.Mui-focused fieldset': {
                                            borderColor: 'skyblue', // Border color when focused
                                        }, '& .MuiInputBase-input': {
                                            fontSize: '14px', // Setting font size
                                        },
                                    }, fontWeight: 400
                                }}
                                onChange={(e) => setNameInput(e.target.value)}
                            />
                            <TextField
                                label="Mobile Number with Country Code"
                                variant="outlined"
                                fullWidth
                                size={"small"}
                                value={numberInput}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start"
                                                                    sx={{fontSize: 'inherit'}}>+91</InputAdornment>,
                                }}
                                placeholder={"8610203336"}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        // Align input text vertically
                                        '& fieldset': {
                                            borderColor: 'grey',
                                            borderRadius: '10px',
                                        },
                                        '&:hover fieldset': {
                                            borderColor: 'grey',
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: 'skyblue',
                                        },
                                        '& .MuiInputBase-input': {
                                            fontSize: '16px',
                                        },
                                        '& .MuiInputAdornment-root': {
                                            fontSize: '16px',
                                        },
                                    }
                                }}
                                onChange={handleChangeNumberInput}
                            />


                            <button
                                onClick={handleAddLead}
                                className={`w-[300px] bg-cc_brand text-white py-1.5 px-4 rounded-lg border-gray-500 flex justify-center items-center   gap-1`}>

                                <Add/>
                                Add Lead
                            </button>

                        </div>


                        <div className={"max-h-[250px] overflow-x-auto mt-4"}>
                            <p className={"text-black text-2xl mb-4 font-semibold"}>Leads List</p>
                            {leads.length > 0 ? (
                                leads.map((lead, index) => (
                                    <FormControlLabel
                                        key={index}
                                        control={
                                            <Checkbox
                                                checked={selectedLeads.has(index)}
                                                onChange={() => handleCheckboxChange(index)}
                                                color="primary"
                                            />
                                        }
                                        label={`${lead.name} : ${lead.number}`}
                                    />
                                ))
                            ) : (
                                <Typography variant="body2">No leads added yet.</Typography>
                            )}
                        </div>
                    </div>

                    <button onClick={handleClearLeads}
                            className={` bg-gray-100 mt-4 border-[1px] hover:bg-gray-200 border-solid border-gray-400 py-1.5 px-3 rounded-xl cursor-pointer flex gap-2 font-medium shadow-lg hover:shadow-xl`}>
                        <Clear/>
                        Clear Leads
                    </button>

                    <Box sx={{flexShrink: 0, mt: 4, alignSelf: 'center'}}>


                        <button
                            onClick={handleSendMessage}
                            disabled={selectedLeads.size === 0 || message.trim() === '' || isLoading}
                            className={`w-full bg-cc_brand text-white p-1.5 rounded-lg border-gray-500 flex justify-center items-center ${(selectedLeads.size === 0 || message.trim() === '') ? "cursor-not-allowed" : "cursor-pointer"} `}>
                            {isLoading &&
                                <CircularProgress sx={{color: "white"}} size={20}/>}
                            <span className={"ml-2"}>{isLoading ? "Loading" : <span className={"flex gap-4"}><Send/>
                        <p>Send Message</p></span>}</span>


                        </button>
                    </Box>

                </div>
                <div
                    className={"w-[40%] border-[1px] border-gray-300 pb-8  h-full rounded-xl bg-white p-5 shadow-[0px_0px_4px_2px_rgba(0,0,0,0.1)]"}>
                    <div className={"h-full"}>
                        <p className={"text-black text-2xl font-semibold mb-2"}>Preview</p>
                        <WhatsappChatBubble 
                            imageTemplates={imageTemplates} 
                            template={selectedOffer ? selectedOffer.offerConstraint : template}
                            WhatsappImagePreview={WhatsappImagePreview || (selectedOffer ? selectedOffer.url : imageTemplates[template])}
                            message={message}
                        />

                    </div>
                </div>

            </div>
        </div>
    )
}

export default Growth;